/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {recipientSelectorSearch} from '../api'

export const useMutationRecipientSelectorSearch = createReactQueryMutationHook('recipientSelectorSearch', recipientSelectorSearch)
